import { takeEvery, put, select } from 'redux-saga/effects';
import { takeValuation, setSelectedContainerId, setTransientValuation, setSelectedValuation, setShouldCalculateProforma, appNotify } from 'store/actions';
import { userSelector, propertyUWStateSelector, transientValuationSelector } from 'store/selectors';
import { removeInvalidProformaInputs } from 'services/taskUWDataService';

export function* takeValuationSaga() {
  yield takeEvery(takeValuation, function* ({ payload }) {
    const { valuationToTake, unmappedValuationsComps } = payload;
    try {
      const { selectedContainerId, selectedProformaInputsContainer } = yield select(propertyUWStateSelector);
      const user = yield select(userSelector);

      const transientValuation = yield select(transientValuationSelector);
      const newTransientValuation = { // create new transient valuation object but with other person's valuation
        ...valuationToTake,
        createdOn: transientValuation.createdOn,
        id: transientValuation.id,
        user: transientValuation.user,
        takenValuationId: valuationToTake.id
      }

      function* callback(invalidFields) {  
        if (unmappedValuationsComps?.length) {
          invalidFields += `\n\nIncompatible comps:`;
          unmappedValuationsComps.forEach(comp => {
            invalidFields += `\n${comp}`;
          });
        }
        
        yield put(appNotify(
          `Took ${valuationToTake.user?.fullName}'s Underwrite` + invalidFields,
          'success',
          {
            persist: invalidFields.length > 0,
            ContentProps: {
              classes: {
                root: 'multilineSnackbarContentRoot',
                message: 'multilineSnackbarContentMessage',
                action: 'multilineSnackbarContentAction'
              }
            }
          }
        ));
      }

      if (selectedContainerId == null) { // On latest container already
        yield put(setSelectedValuation(selectedProformaInputsContainer.valuations.find(x => x.user.id === user.id)));      // set back to user's valuation
        yield put(setTransientValuation(newTransientValuation));
        const { updatedTransientValuation, invalidFields } = yield removeInvalidProformaInputs(newTransientValuation);
        yield put(setTransientValuation(updatedTransientValuation));
        yield put(setShouldCalculateProforma(true));
        yield callback(invalidFields);
      } else {
        yield put(setSelectedContainerId(null, null, newTransientValuation, null, true, callback));
      }
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
    }
  });
}
